import * as $ from './PasswordRequirementItem.styled'

interface PasswordRequirementItemProps {
  passed: boolean
  error: boolean
}
export const PasswordRequirementItem: Settle.FC<PasswordRequirementItemProps> = ({ children, passed, error }) => (
  <$.Check error={!passed && error} data-testid="check-item-root">
    {passed && <$.CheckPassedIcon data-testid="passed-icon" />}
    {!passed && !error && <$.CircleIcon data-testid="neutral-icon" />}
    {!passed && error && <$.ErrorIcon data-testid="error-icon" />}
    {children}
  </$.Check>
)
